import React, { useRef, useState, useEffect } from "react";
import HomeCooperateCard from "../Components/HomeCooperateCard";
import OpportunityCard from "../Components/OpportunityCard";
import { Link, useNavigate } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Skeleton from "@mui/material/Skeleton";
import BenefitCard from "../Components/BenefitCard";
import { useApijobbycategoryQuery } from "../Store/Middleware/api/jobByCategoryAPI";
import bgImage from "../images/colourful_wallpaper.jpg";

const Homepage = () => {
  const { data, isLoading } = useApijobbycategoryQuery();
  const nav = useNavigate();
  const listRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const listEl = listRef.current;
    if (!listEl) return;
    const cardEls = listEl.querySelectorAll(".benefitCard");
    if (!cardEls.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length > 0) {
          const index = Array.from(cardEls).indexOf(visible[0].target);
          setActiveIndex(index);
        }
      },
      {
        root: listEl,
        threshold: 0.6,
      },
    );

    cardEls.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [data]);

  useEffect(() => {
    document.title = "Careers | SpanIdea";
  }, []);

  // Function to safely extract string value from item.value
  const getCategoryValue = (item) => {
    if (!item || !item.value) return "";

    // If value is already a string
    if (typeof item.value === "string") return item.value;

    // If value is an object with value property
    if (item.value.value && typeof item.value.value === "string")
      return item.value.value;

    // If value is an object with name property
    if (item.value.name && typeof item.value.name === "string")
      return item.value.name;

    // Fallback: try to convert to string
    return String(item.value);
  };

  const values = [
    {
      title: "Synergy",
      description:
        "We collaborate seamlessly across teams and clients, combining strengths to deliver innovative and impactful technology solutions.",
    },
    {
      title: "Passion for Excellence",
      description:
        "Driven by passion, we consistently pursue excellence in our work, exceeding expectations with quality and innovation.",
    },
    {
      title: "Accountability",
      description:
        "We take responsibility for our actions, delivering commitments with honesty, transparency, and a results-driven mindset.",
    },
    {
      title: "Nurturing Talent",
      description:
        "We empower our people through learning, mentorship, and growth opportunities, building tomorrow's technology leaders today.",
    },
    {
      title: "Innovation",
      description:
        "We embrace new ideas and technologies, crafting creative solutions that solve real-world challenges and fuel progress.",
    },
    {
      title: "Dedication",
      description:
        "Our unwavering commitment drives us to deliver with focus, persistence, and a customer-first approach every time.",
    },
    {
      title: "Empathy",
      description:
        "We listen, understand, and care fostering respectful relationships with clients, colleagues, and communities we serve.",
    },
    {
      title: "Agility",
      description:
        "We adapt quickly to change, embracing flexibility and speed to deliver value in dynamic business environments.",
    },
  ];

  const benefits = [
    {
      src: "/Health & Insurance.svg",
      title: "Health & Insurance",
      description:
        "Comprehensive health and insurance benefits to ensure your well-being.",
    },
    {
      src: "/Growth & Development.svg",
      title: "Growth & Development",
      description:
        "Opportunities for continuous learning and professional development.",
    },
    {
      src: "/Balanced Lifestyle.svg",
      title: "Balanced lifestyle",
      description: "Promoting a healthy work-life balance for all employees.",
    },
    {
      src: "/Competitive Pay.svg",
      title: "Competitive pay",
      description:
        "Attractive salary packages that reflect your skills and contributions.",
    },
    {
      src: "/employee reward.svg",
      title: "Rewarded",
      description:
        "Recognition and rewards for outstanding performance and contributions.",
    },
    {
      src: "/Recognized.svg",
      title: "Recognized",
      description:
        "Acknowledgment of your efforts and achievements within the company.",
    },
  ];

  const opportunities = [
    { title: "Experienced Hires", Imgsrc: "/Experienced.jpg" },
    { title: "Students", Imgsrc: "/student.jpg" },
    { title: "Additional opportunities", Imgsrc: "/additional benifits.jpg" },
  ];

  return (
    <section className="homepageSection">
      <div className="homepageMain">
        <div className="homepageContent">
          <div className="homepageFontMain">
            <div className="homepageFont-m1">
              Unleash Your Creativity In The Tech Industry
            </div>
            <div className="homepageFont-m2">
              At Spanidea, we are a leading technology company dedicated to
              pushing the boundaries of what's possible. We believe that the
              power of technology can transform businesses, industries, and the
              world around us. As we continue to grow and expand, we are
              actively seeking top-notch talent to join our dynamic team.
            </div>
          </div>

          <div>
            <Link to="/authPage/jobdetails/openposition" className="linkClass">
              <div className="searchOpenButton">
                <span className="searchOpenButtonText">Search Open Roles </span>
                <span className="searchOpenButtonText-2">→</span>
              </div>
            </Link>
          </div>
        </div>

        <div className="homeImageSection">
          <div className="columns">
            <div className="column">
              <img src="/1.jpg" alt="img1" className="gridImage" />
              <img src="/2.jpg" alt="img2" className="gridImage" />
              <img src="/3.jpg" alt="img3" className="gridImage" />
            </div>
            <div className="column">
              <img src="/7.jpg" alt="img7" className="gridImage" />
              <img src="/8.jpg" alt="img8" className="gridImage" />
              <img src="/9.jpg" alt="img9" className="gridImage" />
              <img src="/10.jpg" alt="img10" className="gridImage" />
            </div>
            <div className="column">
              <img src="/4.jpg" alt="img4" className="gridImage" />
              <img src="/5.jpg" alt="img5" className="gridImage" />
              <img src="/11.jpg" alt="img6" className="gridImage" />
            </div>
          </div>
        </div>
      </div>

      <div className="trendingJobSection">
        <div className="trendingJobMain">
          <div className="trendingJobMainFont-m1">Trending jobs with us</div>
          <div className="trendingJobMainFont-m2">
            Browse through the tops jobs
          </div>
        </div>

        {isLoading ? (
          <div className="trendingJobSectionGrid">
            {Array(6)
              .fill()
              .map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rounded"
                  width={300}
                  height={113}
                  sx={{ bgcolor: "grey.700" }}
                />
              ))}
          </div>
        ) : (
          <div className="trendingJobSectionGrid">
            {data?.message?.slice(0, 6).map((item, idx) => {
              // SAFELY extract the category value as string
              let categoryValue = "";

              if (item?.value) {
                if (typeof item.value === "string") {
                  categoryValue = item.value;
                } else if (typeof item.value === "object") {
                  categoryValue = item.value.value || item.value.name || "";
                }
              }

              // If still empty, try using item.name
              if (!categoryValue && item?.name) {
                categoryValue = typeof item.name === "string" ? item.name : "";
              }

              // Final fallback
              if (!categoryValue) {
                categoryValue = `Category-${idx}`;
              }

              const totalJobs = item?.total || 0;

              return (
                <div
                  className="trendingJobCard"
                  key={idx}
                  onClick={() =>
                    nav(`/authPage/jobdetails/openposition`, {
                      state: { category: categoryValue, isHome: true },
                    })
                  }
                >
                  <div className="trendingJobCard_text">{categoryValue}</div>
                  <div className="trendingJobCard_link">
                    {totalJobs}+ Jobs{" "}
                    <ChevronRightIcon size={16} color="#38c4ec" />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div
        className="corporateValueContainer"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <span className="corporateValueHeading">Corporate Values</span>
          <p className="corporateValueDescription">
            Our corporate values shape our approach to business and influence
            every action we take. We focus on trust, continuous improvement,
            teamwork, and a commitment to delivering high-quality solutions,
            creating an environment that promotes growth and success for all.
          </p>
        </div>

        <div className="corporateValueGrid">
          {values.map((value, index) => (
            <HomeCooperateCard
              key={index}
              title={value.title}
              description={value.description}
            />
          ))}
        </div>
      </div>

      <div className="benefitSection">
        <div className="benefitContainer">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <div className="benefitFont">Benefits</div>
            <div className="benefitFont-m2">
              At Spanidea, we believe in harnessing the power of technology to
              create exceptional online experiences for businesses. By joining
              our team, you'll enjoy a wide range of benefits that contribute to
              your professional growth, work-life balance, and overall job
              satisfaction.
            </div>
          </div>

          <div className="benefitCardWrapper">
            <div className="benefitCardList" ref={listRef}>
              {benefits.map((card, index) => (
                <BenefitCard
                  key={index}
                  src={card.src}
                  title={card.title}
                  description={card.description}
                />
              ))}
            </div>
            <div className="bullets">
              {benefits.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === activeIndex ? "active" : ""}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="opportunitieSection">
        <div className="opportunitieContainer">
          <div className="opportunitieFont">
            Explore Opportunities for every stage of your career
          </div>
          <div className="opportunitieSectionGrid">
            {opportunities.map((opportunity, index) => (
              <OpportunityCard
                key={index}
                title={opportunity.title}
                Imgsrc={opportunity.Imgsrc}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="effortlesSection">
        <div className="effortlesContainer">
          <div className="effortlesContent">
            <div className="effortlesFont-m1">
              Effortless job applications at your fingertips
            </div>
            <div className="effortlesFont-m2">
              Start applying to your dream job now. No login required
            </div>
          </div>
          <div className="effortlesButtonArea">
            <Link to="/authPage/jobdetails/openposition" className="linkClass">
              <div className="effortlesButton">
                <span className="effortlesFont-m3">Search Open Roles </span>
                <span className="effortlesFont-m4">→</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Homepage;
